define(["./numberModule"], function (numberModule) {
    "use strict";

    return numberModule.filter("mathAbs", [function () {
        return function (number) {
            return Math.abs(number);
        };
    }]);
});